import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { IndicatorFilter } from '../domain/indicatorGauge';

export interface IndicatorFiltersSlice {
    selected: IndicatorFilter[];
}

const initialState: IndicatorFiltersSlice = {
    selected: [],
};

const indicatorFiltersSlice = createSlice({
    initialState,
    name: 'indicatorFilters',
    reducers: {
        setIndicatorFilters: (state, action: PayloadAction<IndicatorFilter[]>) => {
            state.selected = action.payload;
        },
    },
});

export const { setIndicatorFilters } = indicatorFiltersSlice.actions;
export default indicatorFiltersSlice.reducer;
